/**
 * Copyright Mántum All Rights Reserved.
 */
export const language = () => {
    if (window && typeof window !== 'undefined') {
        if (navigator && navigator.language) {
            return navigator.language.includes('es') ? 'es' : 'en';
        }
    }
    return 'es';
};
